import React from "react";
// Common Components
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import { FileDownloader } from "src/Components";
// Requests
import {
  getGeneralViewTable,
  getGeneralViewExcelFile,
} from "src/Requests/imePortfolio";
// Types
import {
  IGeneralViewSearchParams,
  IGeneralViewTableReport,
} from "src/Interfaces/imePortfolio";

const GeneralView: React.FC = () => {
  return (
    <div className="w-full h-full p-5">
      <FileDownloader getFile={getGeneralViewExcelFile} />
      <TableTemplate<IGeneralViewSearchParams, IGeneralViewTableReport>
        TableUI={({ reports, onAction, sortingType, setSortingType }) => {
          return (
            <CommonTableUI
              reports={reports}
              onAction={onAction}
              sortingType={sortingType}
              setSortingType={setSortingType}
              tableBoxClassName="max-h-[700px] overflow-auto"
            />
          );
        }}
        getDataTable={getGeneralViewTable}
        withSort
      />
    </div>
  );
};

export default GeneralView;
